import React from 'react';

import { formatCpf } from '../../../../../utils';
/** components */
import Flex, { Grid } from '../../../../../components/Flex';
import { IProximity } from '../../../../../interfaces';

import {
  Container,
} from './styles';

interface ICard {
  proximity: IProximity;
  type: string;
}

const Card: React.FC<ICard> = ({ proximity }) => {

  return (
    <Grid item xs={12}>
      <Container >
 
        <Grid container spacing={1} justify="space-between">
          <Flex title="Nome" xs={12} sm={4} md={4}>
            <b> {proximity?.name} </b>
          </Flex>
          <Flex title="CPF" xs={12} sm={4} md={4}>
            <b> {proximity.document ? formatCpf(proximity.document) : 'não informado'} </b>
          </Flex>
        </Grid>
        {proximity?.store && (
          <Grid item xs={12} sm={8} md={6}>
            <Flex title="Establecimento" xs={12} sm={8} md={6}>
              <b> {proximity?.store} </b>
            </Flex>
          </Grid>
        )}
        <Grid container spacing={1} justify="space-between">
          <Flex title="Telefone de Contato" xs={6} sm={4} md={4}>
            <b> {proximity.phone || 'não informado'} </b>
          </Flex>
          <Flex title="E-mail" xs={6} sm={4} md={4}>
            <b> {proximity.email || 'não informado'} </b>
          </Flex>
          <Flex title="CEP" xs={12} sm={4} md={4}>
            <b> {proximity.cep || 'não informado'} </b>
          </Flex>
          <Flex title="Logradouro" xs={6} sm={4} md={4}>
            <b> {proximity.street || 'não informado'} </b>
          </Flex>
          <Flex title="Nº" xs={6} sm={4} md={4}>
            <b> {proximity.number || 'não informado'} </b>
          </Flex>
          <Flex title="Bairro" xs={12} sm={4} md={4}>
            <b> {proximity.distric || 'não informado'} </b>
          </Flex>
          <Flex title="Complemento" xs={12} sm={4} md={4}>
            <b> {proximity.complement || 'não informado'} </b>
          </Flex>

          <Grid container spacing={1} justify="space-between">
            <Grid item xs={12} sm="auto">
              <Flex title="Relato da abordagem">
                <b>{proximity.description}</b>
              </Flex>
            </Grid>
          </Grid>

          <Grid container spacing={1} justify="space-between">
            <Flex title="Agente" xs={6} sm={4} md={4}>
              <b>{(proximity.user?.name)}</b>
            </Flex>
            <Flex title="Gerência" xs={6} sm={4} md={4}>
              <b>{proximity.managements?.name}</b>
            </Flex>
            <Flex title="Setor" xs={6} sm={4} md={4}>
              <b>{proximity.sectors?.name}</b>
            </Flex>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

export default Card;
